<template>
    <app-title :title="subtitle" />
    <!-- eslint-disable max-len -->
    <section class="max-w-xl mx-auto px-5">
        <div class="rounded-3xl p-10 my-20 bg-slate-800/60 ring-1 ring-slate-300/10">
            <h2 class="text-2xl text-center bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent mb-10 xl:text-3xl">
                {{ trans['messages.auth.reset'] }}
            </h2>
            <form method="post"
                  novalidate
                  @submit.prevent="submit">
                <input v-model="form.token"
                       name="token"
                       type="hidden">
                <div class="mb-4">
                    <input v-model="form.email"
                           class="form-input block w-full"
                           :class="{'form-invalid': form.errors.email}"
                           type="text"
                           name="email"
                           :placeholder="trans['validation.attributes.email']"
                           required>
                    <div v-if="form.errors.email" class="mt-2 text-sm text-red-500">
                        {{ form.errors.email }}
                    </div>
                </div>
                <div class="mb-4">
                    <input v-model="form.password"
                           class="form-input block w-full"
                           :class="{'form-invalid': form.errors.password}"
                           type="password"
                           name="password"
                           :placeholder="trans['validation.attributes.password']"
                           required>
                    <div v-if="form.errors.password" class="mt-2 text-sm text-red-500">
                        {{ form.errors.password }}
                    </div>
                </div>
                <div class="mb-10">
                    <input v-model="form.password_confirmation"
                           class="form-input block w-full"
                           :class="{'form-invalid': form.errors.password_confirmation}"
                           type="password"
                           name="password_confirmation"
                           :placeholder="trans['validation.attributes.password_confirmation']"
                           required>
                    <div v-if="form.errors.password_confirmation" class="mt-2 text-sm text-red-500">
                        {{ form.errors.password_confirmation }}
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="btn-sky font-semibold px-12"
                            type="submit"
                            :disabled="form.processing">
                        {{ subtitle }}
                    </button>
                </div>
            </form>
        </div>
    </section>
    <!-- eslint-enable max-len -->
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { useForm } from '@inertiajs/vue3';
import Layout from '../../base/Layout';

const { email, token } = defineProps({
    email: {
        type: String,
        required: true
    },

    token: {
        type: String,
        required: true
    },

    trans: {
        type: Object,
        required: true
    }
});

defineOptions({
    layout: Layout
});

const subtitle = ref('Reset Password');

const form = useForm({
    token,
    email,
    password: '',
    password_confirmation: ''
});

const submit = () => {
    form.post(route('password.update'), {
        onFinish: () => form.reset('password', 'password_confirmation')
    });
};
</script>
